export default __webpack_public_path__ + "static/torquemoney-f6b40dd94ab01eb51bb2853fe05146d7.jpg";